import React from "react";
import theme from "@monorepo/styles/theme";
import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/system";

import { StyledCard } from "./Card.styles";

export enum CardSizesEnum {
  SMALL = "small",
  DEFAULT = "default",
  BIG = "big",
}

interface ICardProps {
  text?: string;
  icon?: React.ReactNode;
  iconUsesStroke?: boolean;
  iconPosition?: "left" | "right";
  active?: boolean;
  size?: CardSizesEnum;
  className?: string;
  sx?: SxProps;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onKeyPress?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  // passed as ...rest
  disabled?: boolean;
  unclickable?: boolean;
}

export const Card: React.FC<ICardProps> = ({
  text,
  icon,
  iconUsesStroke,
  iconPosition = "right",
  active,
  children,
  onClick,
  onKeyPress,
  size = CardSizesEnum.DEFAULT,
  className,
  sx,
  ...rest
}) => {
  return (
    <StyledCard
      size={size}
      sx={sx}
      onClick={(e) => onClick?.(e)}
      onKeyPress={(e) => onKeyPress?.(e)}
      role="menuitem"
      tabIndex={0}
      className={className}
      icon={!!icon}
      iconPosition={iconPosition}
      active={!!active}
      iconUsesStroke={iconUsesStroke}
      {...rest}
    >
      {children || (
        <>
          <Typography
            component="span"
            sx={{
              order: iconPosition === "left" ? 2 : 0,
              userSelect: "none",
              fontSize: theme.typography.subtitle1.fontSize,
              ...sx,
              marginLeft: iconPosition === "left" ? 0 : "inherit",
            }}
          >
            {text}
          </Typography>
        </>
      )}
      {icon && (
        <Box
          sx={{
            "& > svg": {
              placeSelf: "center",
              alignSelf: "center",
            },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            placeSelf: iconPosition === "left" ? "flex-start" : "flex-end",
            alignSelf: "center",
            color: active ? "inherit" : theme.palette.primary.main,
          }}
        >
          {icon}
        </Box>
      )}
    </StyledCard>
  );
};
